import { Button, Collapse, Input, Select, message, Tooltip, Modal } from 'antd';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import {
  fetchBlackList,
  fetchTypologiesOfScenario,
  putTypologyOfScenariosListDataWorker
} from '../../../../redux/actions/trm/trmDashboard';
import { fetchTypologiesActions } from '../../../../redux/actions/common';
import ConfigureDrawer from '../ConfigureDrawer';
import FlagRed from '../../../../assets/flag_Red.svg';
import { cloneDeep, countBy, keys, map, pickBy } from 'lodash';

import style from './style.scss';

const { Panel } = Collapse;

function TypologyRules({
  fetchTypologiesOfScenarioData,
  scenarioID,
  trmDashboard,
  fetchTypologiesActionsData,
  putTypologyOfScenariosListData,
  trmActions,
  fetchBlackListApi
}) {
  const drawerRef = useRef(null);
  const [scenarioTypologies, setTypologyScenarios] = useState();
  const [currentLetter, setCurrentLetter] = useState('A');
  const [typologyActions, setActions] = useState([]);
  const [ruleActions, setRuleActions] = useState([]);
  const [variantRenderData, setVariantRenderData] = useState([]);
  const [currentlyEditedVariantId, setCurrentlyEditedVariantId] =
    useState(null);
  const [hasDuplicateNames, setHasDuplicateNames] = useState(false);
  const [variantNameMaxLength] = useState(200);
  const [messageVariantLength, setMessageVariantLength] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [variantToDelete, setVariantToDelete] = useState(null);
  const [updateData, setUpdateData] = useState(0);
  const [selectedTypoId, setSelectedTypoId] = useState(null);

  useEffect(() => {
    fetchTypologiesOfScenarioData({
      scenarioID: scenarioID
    });
    fetchTypologiesActionsData();
    fetchBlackListApi();
  }, []);

  useEffect(() => {
    setScenarioData();
  }, [scenarioTypologies]);

  const setScenarioData = () => {
    const exisitngData = [];
    scenarioTypologies?.typologies?.forEach((typology) => {
      if (typology.rules) {
        const rules = JSON.parse(typology.rules);
        const variants = rules.map((rule, index) => ({
          ...rule,
          variantName: rule.ruleName,
          action: '',
          typologyId: typology.id,
          variantId: rule.ruleId,
          isEditable: false
        }));

        exisitngData.push({
          typoRules: rules,
          typologyName: typology.title,
          typologyId: typology.id,
          variants
        });
      } else {
        exisitngData.push({
          typoRules: [],
          typologyName: typology.title,
          typologyId: typology.id,
          variants: []
        });
      }
    });
    setVariantRenderData(exisitngData);
  };

  useEffect(() => {
    const existingNames = new Set();
    let hasDuplicates = false;
    variantRenderData.forEach((typology) => {
      typology.variants.forEach((variant) => {
        if (existingNames.has(variant.variantName)) {
          hasDuplicates = true;
        } else {
          existingNames.add(variant.variantName);
        }
      });
    });
    const exceedsMaxLength = variantRenderData.some((typology) =>
      typology.variants.some(
        (variant) => variant.variantName.length > variantNameMaxLength
      )
    );

    const minLength = variantRenderData.some((typology) =>
      typology.variants.some((variant) => variant.variantName.length <= 0)
    );

    setHasDuplicateNames(hasDuplicates || exceedsMaxLength || minLength);
    setMessageVariantLength(hasDuplicates);
  }, [variantRenderData]);

  useEffect(() => {
    if (trmDashboard && trmDashboard.scenarioTypologiesList) {
      setTypologyScenarios(trmDashboard.scenarioTypologiesList.data);
    }
  }, [trmDashboard.scenarioTypologiesList]);

  useEffect(() => {
    if (trmActions?.data != null) {
      setActions(trmActions?.data);
    }
  }, [currentLetter, trmActions]);

  useEffect(() => {
    let updatedRuleActions = [];

    Object.keys(typologyActions).forEach((key) => {
      const innerObject = typologyActions[key];
      updatedRuleActions.push(innerObject);
    });

    setRuleActions(updatedRuleActions);
  }, [typologyActions]);

  const onDrawerOpen = (defaultTab = 0, record, typoIndex, variantIndex) => {
    drawerRef.current?.showDrawer(defaultTab, record, typoIndex, variantIndex);
  };

  const generateUniqueVariantId = (typologyId) => {
    return `${typologyId}_clone_${new Date().getTime()}`;
  };

  const handleDeleteVariant = (typologyId, variantId) => {
    // Find the variant to delete
    const variant = variantRenderData
      .find((typology) => typology.typologyId === typologyId)
      .variants.find((variant) => variant.variantId === variantId);

    // Set the variant to delete
    setVariantToDelete(variant);

    // Show the delete confirmation modal
    setIsDeleteModalVisible(true);
  };

  useEffect(() => {
    if (updateData > 0) {
      handleSaveTypology();
    }
  }, [updateData]);

  const handleDeleteConfirmation = () => {
    // Close the delete confirmation modal
    setIsDeleteModalVisible(false);

    // Delete the variant
    if (variantToDelete) {
      const { typologyId, variantId } = variantToDelete;
      setVariantRenderData((prevData) =>
        prevData.map((typology) => {
          if (typology.typologyId === typologyId) {
            const updatedVariants = typology.variants.filter(
              (variant) => variant.variantId !== variantId
            );
            return {
              ...typology,
              variants: updatedVariants
            };
          } else {
            return typology;
          }
        })
      );
      setSelectedTypoId(typologyId);
      setUpdateData((prev) => prev + 1);
    }
  };

  const onCloneClick = (typologyIDclicked, title) => {
    const clonedTypology = variantRenderData.find(
      (typology) => typology.typologyId === typologyIDclicked
    );
    if (clonedTypology) {
      const lastRuleIndex = clonedTypology.typoRules.length - 1;
      const lastRule = clonedTypology.typoRules[lastRuleIndex];
      const newVariantId = generateUniqueVariantId(typologyIDclicked);
      const newVariantName = `${lastRule.ruleName}_clone_${String.fromCharCode(
        64 + clonedTypology.variants.length
      )}`;

      const newVariant = {
        matchAction: '',
        typologyId: typologyIDclicked,
        isEditable: false,
        ...lastRule,
        variantId: newVariantId,
        variantName: newVariantName,
        ruleName: newVariantName,
        ruleId: newVariantId
      };

      setVariantRenderData((prevData) => {
        const updatedData = prevData.map((typology) => {
          if (typology.typologyId === typologyIDclicked) {
            return {
              ...typology,
              variants: [...typology.variants, cloneDeep(newVariant)]
            };
          }
          return typology;
        });
        return updatedData;
      });

      setSelectedTypoId(typologyIDclicked);
      setUpdateData((prev) => prev + 1);
    }
  };

  const toggleEditVariant = (typologyId, variantId) => {
    setVariantRenderData((prevData) => {
      return prevData.map((typology) => {
        if (typology.typologyId === typologyId) {
          return {
            ...typology,
            variants: typology.variants.map((variant) => {
              if (variant.variantId === variantId) {
                setCurrentlyEditedVariantId(variantId);
                return {
                  ...variant,
                  isEditing: true
                };
              } else {
                return {
                  ...variant,
                  isEditing: false
                };
              }
            })
          };
        } else {
          return typology;
        }
      });
    });
  };

  const handleVariantNameChange = (
    typologyId,
    variantId,
    newName,
    variantIndex
  ) => {
    // Check if the variant name exceeds the maximum length
    if (newName.length > variantNameMaxLength) {
      document.getElementById(`error-input-${variantIndex}`).innerHTML =
        'Variant name exceeds 200 characters.';
    } else {
      document.getElementById(`error-input-${variantIndex}`).innerHTML = '';
    }

    setVariantRenderData((prevData) => {
      return prevData.map((typology) => {
        if (typology.typologyId === typologyId) {
          return {
            ...typology,
            variants: typology.variants.map((variant) => {
              if (variant.variantId === variantId) {
                return {
                  ...variant,
                  variantName: newName
                };
              } else {
                return variant;
              }
            })
          };
        } else {
          return typology;
        }
      });
    });
  };

  const handleActionSelect = (typologyId, variantId, selectedAction) => {
    setVariantRenderData((prevData) => {
      return prevData.map((typology) => {
        if (typology.typologyId === typologyId) {
          return {
            ...typology,
            variants: typology.variants.map((variant) => {
              if (variant.variantId === variantId) {
                return {
                  ...variant,
                  matchAction: selectedAction
                };
              } else {
                return variant;
              }
            })
          };
        } else {
          return typology;
        }
      });
    });
    setSelectedTypoId(typologyId);
    setUpdateData((prev) => prev + 1);
  };

  const handleSaveTypology = useCallback(
    (typologyId) => {
      const typoIdToUpdate = typologyId || selectedTypoId;
      const existingNames = new Set();
      let hasDuplicates = false;
      variantRenderData.forEach((typology) => {
        typology.variants.forEach((variant) => {
          if (existingNames.has(variant.variantName)) {
            hasDuplicates = true;
          } else {
            existingNames.add(variant.variantName);
          }
        });
      });
      const exceedsMaxLength = variantRenderData.some((typology) =>
        typology.variants.some(
          (variant) => variant.variantName.length > variantNameMaxLength
        )
      );
      variantRenderData
        .filter((f) => f.typologyId === typoIdToUpdate)
        .map((v) => {
          let error = false;
          v.variants.forEach((vari, index) => {
            if (document.getElementById(`error-input-${index}`)) {
              document.getElementById(`error-input-${index}`).innerHTML = ``;
            }
            const functionNames = map(vari.function || [], 'name');
            const duplicates = keys(
              pickBy(countBy(functionNames), (count) => count > 1)
            );
            if (duplicates.length > 0) {
              message.error({
                key: 'err',
                content: `Duplicate function names found: ${duplicates.toString()}`
              });
              error = true;
              return;
            } else if (hasDuplicates) {
              error = true;
              message.error({
                key: 'err',
                content: `Found duplicate. Variant names must be unique.`
              });
              return;
            } else if (exceedsMaxLength) {
              error = true;
              message.error({
                key: 'err',
                content: `Variant Name exceeds ${variantNameMaxLength} character.`
              });
              return;
            }
          });
          if (v.variants.filter((v) => !v.variantName).length > 0) {
            error = true;
            message.error({
              key: 'err',
              content: `Please enter variant name`
            });
            return;
          }
          if (!error) {
            const dataToSave = {
              scenarioID,
              data: {
                typologyId: v.typologyId,
                rules: JSON.stringify(
                  v.variants.map((rule) => {
                    return {
                      ruleId: rule.ruleId,
                      ruleName: rule.variantName,
                      condition: rule.condition,
                      function: rule.function,
                      functionAggregation: rule.functionAggregation,
                      matchAction: rule.matchAction,
                      parameterMap: rule.parameterMap,
                      typologyId: rule.typologyId,
                      typologyName: rule.typologyName
                    };
                  })
                )
              }
            };
            putTypologyOfScenariosListData(dataToSave);
          }
        });
      setUpdateData(0);
    },
    [variantRenderData]
  );

  const handleClickTemp = (e, typologyIDclicked, ruleIndex) => {
    e.stopPropagation();
    const clonedTypology = variantRenderData.find(
      (typology) => typology.typologyId === typologyIDclicked
    );
    if (clonedTypology) {
      const lastRule = clonedTypology.variants[ruleIndex];
      const newVariantId = generateUniqueVariantId(typologyIDclicked);
      const newVariantName = `${lastRule.ruleName}_clone_${String.fromCharCode(
        64 + clonedTypology.variants.length
      )}`;

      const newVariant = {
        matchAction: '',
        typologyId: typologyIDclicked,
        isEditable: false,
        ...lastRule,
        variantId: newVariantId,
        variantName: newVariantName,
        ruleName: newVariantName,
        ruleId: newVariantId
      };

      setVariantRenderData((prevData) => {
        const updatedData = prevData.map((typology) => {
          if (typology.typologyId === typologyIDclicked) {
            return {
              ...typology,
              variants: [...typology.variants, cloneDeep(newVariant)]
            };
          }
          return typology;
        });
        return updatedData;
      });
      setSelectedTypoId(typologyIDclicked);
      setUpdateData((prev) => prev + 1);
    }
  };
  return (
    <>
      <div className={style.instanceTitle}>
        <div className={style.topPanelHeaders}>
          <p>Typologies</p>
          <span>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <img
              alt=""
              style={{ height: '26px', paddingBottom: '2px' }}
              src={FlagRed}
            />
            &nbsp; Fraud Prevention
          </span>
        </div>
        {/* <Button
          onClick={handleSaveTypology}
          className={style.saveBtn}
          disabled={hasDuplicateNames} // Disable the button if there are duplicate names
        >
          Save
        </Button> */}
      </div>
      <div style={{ paddingBottom: '20px' }}>
        <Collapse className={style.typologiesCollapse}>
          <ConfigureDrawer
            setVariantRenderData={setVariantRenderData}
            variantRenderData={variantRenderData}
            typologies={scenarioTypologies?.typologies || []}
            ref={drawerRef}
            isReadOnly={false}
            handleSaveTypology={handleSaveTypology}
            setScenarioData={setScenarioData}
          />
          {variantRenderData.map((typology, typoIndex) => {
            return (
              <Panel
                header={
                  <CustomCollapseHeader
                    variantRenderData={variantRenderData}
                    onCloneClick={(typologyIDclicked, title) =>
                      onCloneClick(typologyIDclicked, title)
                    }
                    title={typology.typologyName}
                    typologyId={typology.typologyId}
                  />
                }
                key={typology.id}>
                <div>
                  <div className={style.flexHeaders}>
                    <p>Variants</p>
                    <p style={{ width: '30%' }}>Actions</p>
                  </div>

                  {typology.variants.length === 0 ? (
                    <div className={style.noDataPhrase}>
                      <p>No Data</p>
                    </div>
                  ) : (
                    typology.variants.map((variant, variantIndex) => (
                      <div className={style.dataRow} key={variantIndex}>
                        <div>
                          <div>
                            {currentlyEditedVariantId === variant.variantId ? (
                              <Input
                                type="text"
                                value={variant.variantName}
                                onChange={(e) =>
                                  handleVariantNameChange(
                                    typology.typologyId,
                                    variant.variantId,
                                    e.target.value,
                                    variantIndex
                                  )
                                }
                                onBlur={() => {
                                  setCurrentlyEditedVariantId(null);
                                  handleSaveTypology(typology.typologyId);
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  display: 'flex',
                                  marginBottom: '10px'
                                }}>
                                <p
                                  style={{
                                    marginRight: '10px',
                                    maxWidth: '500px',
                                    wordWrap: 'break-word'
                                  }}>
                                  {variant.variantName}
                                </p>
                                <span>
                                  <i
                                    className="fa fa-pencil"
                                    aria-hidden="true"
                                    onClick={() =>
                                      toggleEditVariant(
                                        typology.typologyId,
                                        variant.variantId
                                      )
                                    }></i>
                                </span>
                                {/* <Tooltip title="Clone">
                                  <button
                                    style={{ background: 'none' }}
                                    onClick={(e) =>
                                      handleClickTemp(
                                        e,
                                        typology.typologyId,
                                        variantIndex
                                      )
                                    }
                                    className={style.cloneButton}>
                                    <i className="fa fa-clone"></i>
                                  </button>
                                </Tooltip> */}
                              </div>
                            )}
                          </div>
                          <span
                            className={style.errorMessage}
                            id={`error-input-${variantIndex}`}></span>
                        </div>

                        <div className={style.actions}>
                          <Select
                            style={{ width: 120 }}
                            value={variant.matchAction}
                            onChange={(value) =>
                              handleActionSelect(
                                typology.typologyId,
                                variant.variantId,
                                value
                              )
                            }>
                            {ruleActions.map((rule, index) => (
                              <Select.Option
                                key={index}
                                value={rule.displayName}>
                                {rule.displayName}
                              </Select.Option>
                            ))}
                          </Select>
                          <button
                            style={{ background: 'none' }}
                            onClick={() =>
                              onDrawerOpen(0, variant, typoIndex, variantIndex)
                            }
                            className={style.configureBtn}>
                            Configure
                          </button>
                          {typology.variants.length > 1 && (
                            <button
                              style={{
                                background: 'none',
                                marginTop: '3px',
                                color: '#D0D7E3'
                              }}
                              onClick={() =>
                                handleDeleteVariant(
                                  typology.typologyId,
                                  variant.variantId
                                )
                              }>
                              <i className="fa fa-close"></i>
                            </button>
                          )}
                          <Modal
                            title="Confirm Deletion"
                            className={style.modalDelete}
                            visible={isDeleteModalVisible}
                            onOk={handleDeleteConfirmation}
                            onCancel={() => setIsDeleteModalVisible(false)}>
                            Are you sure you want to delete this variant?
                          </Modal>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </Panel>
            );
          })}
        </Collapse>
        {messageVariantLength && (
          <div className={style.duplicateMessage}>
            * Variant names must be unique. Please enter unique names.
          </div>
        )}
      </div>
    </>
  );
}

const CustomCollapseHeader = ({
  onCloneClick,
  title,
  typologyId,
  variantRenderData
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onCloneClick(typologyId, title);
  };

  // Calculate the number of variants for the current typology
  let count = 0;
  variantRenderData.forEach((typology) => {
    if (typology.typologyId === typologyId) {
      count = typology.variants.length;
    }
  });

  return (
    <div className={style.customCollapseHeader}>
      <div className={style.title} style={{ width: 'auto' }}>
        {title}
      </div>
      <Tooltip title="Clone">
        <button
          style={{ background: 'none' }}
          onClick={handleClick}
          className={style.cloneButton}>
          <i className="fa fa-clone"></i>
        </button>
      </Tooltip>
      <p className={style.variationLabel}>
        {count} {count === 1 ? 'Variant' : 'Variants'}
      </p>
    </div>
  );
};

function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    fetchTypologiesOfScenarioData: (payload) => {
      dispatch(fetchTypologiesOfScenario(payload));
    },
    putTypologyOfScenariosListData: (payload) => {
      dispatch(putTypologyOfScenariosListDataWorker(payload));
    },
    fetchTypologiesActionsData: (payload) => {
      dispatch(fetchTypologiesActions());
    },
    fetchBlackListApi: (payload) => {
      dispatch(fetchBlackList(payload));
    }
  };
}

function mapStateToProps(state, ownProps = {}) {
  return {
    trmDashboard: state.trmDashboard,
    trmActions: state.amlsCommon.commonTypologyAction,
    authentication: state.authentication.data
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TypologyRules);
